
import { ref, defineComponent } from 'vue'
import MynaviLinks from '@/components/block/MynaviLinks.vue'
import BreadCrumb from '@/components/elements/BreadCrumb.vue'
import smoothscroll from 'smoothscroll-polyfill'

export default defineComponent({
  name: 'Footer',

  components: {
    MynaviLinks,
    BreadCrumb
  },

  setup() {
    smoothscroll.polyfill()

    const toPageTop = () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }

    const innerLinks = [
      {
        link: '/guide',
        label: 'ご利用ガイド'
      },
      {
        link: '/news',
        label: 'お知らせ'
      },
      {
        link: '/faq',
        label: 'よくある質問'
      },
      {
        link: '/contact/input',
        label: 'お問い合わせ'
      },
      {
        link: '/sitemap',
        label: 'サイトマップ'
      },
      {
        link: '/terms',
        label: '利用規約・個人情報保護方針'
      },
      {
        link: '/privacy_policy',
        label: '個人情報の取扱について'
      }
    ]

    const companyLinks01 = [
      {
        link: 'https://www.mynavi.jp/company/',
        label: '会社概要'
      },
      {
        link: 'https://www.mynavi.jp/access/',
        label: 'アクセス'
      },
      {
        link: 'https://www.mynavi.jp/company/sustainability/',
        label: 'サスティナビリティ'
      }
    ]

    const companyLinks02 = [
      {
        link: 'https://www.mynavi.jp/recruit/',
        label: '採用'
      },
      {
        link: 'https://www.mynavi.jp/company/group/',
        label: 'グループ企業'
      },
      {
        link: 'https://www.mynavi.jp/privacy/',
        label: '個人情報保護方針'
      }
    ]

    const logoImgUrl = ref('https://conts1.mynv.jp/privacy.png')
    const onImgError = () => {
      logoImgUrl.value = 'https://conts2.mynv.jp/privacy.png'
    }
    return {
      toPageTop,
      innerLinks,
      companyLinks01,
      companyLinks02,
      logoImgUrl,
      onImgError
    }
  }
})
